import React from "react";
import { Icon } from "../../components/Icon";

const STEP_BUTTONS = [
  { key: "DetectChapterHolesStep", label: "Coach", icon: <Icon.ProjectIssues /> },
];

/**
 * Row of small avatar buttons for opening chapter-step result side panels.
 *
 * Props:
 *  - onStepClick(stepKey: string): void
 *  - activeStep: string | null  — currently active step key
 *  - tasksCount: number         — total tasks (holes + show-vs-tell + pacing)
 */
const StepResultButtons = ({
  onStepClick,
  activeStep,
  tasksCount = 0,
}) => (
  <>
    {STEP_BUTTONS.map(({ key, label, icon }) => {
      const isTasks = key === 'DetectChapterHolesStep';
      const issueCount = isTasks ? Math.max(0, Number(tasksCount) || 0) : 0;
      const countLabel = issueCount > 99 ? '99+' : String(issueCount);
      const title = issueCount > 0 ? `View ${label} (${issueCount})` : `View ${label}`;
      const importanceClass = isTasks ? ' scenes-avatar-count--high' : '';
      return (
      <button
        key={key}
        type="button"
        className={`scenes-avatar-btn${activeStep === key ? ' scenes-avatar-btn--active' : ''}${isTasks ? ' scenes-avatar-btn--holes' : ''}`}
        onClick={() => onStepClick(key)}
        title={title}
        aria-label={title}
      >
        <span className="scenes-avatar-icon">
          {icon}
          {issueCount > 0 && <span className={`scenes-avatar-count${importanceClass}`} aria-hidden="true">{countLabel}</span>}
        </span>
        <span className="scenes-avatar-hint">{label}</span>
      </button>
      );
    })}
  </>
);

export default StepResultButtons;
export { STEP_BUTTONS };
